<div (click)="this.main?.linkBlank(this.generateUrl())" [class.mt-3]="this.showDescription"
    class="cardNews cursor-pointer">
    <div [class.moreHeight]="this.showDescription" class="cardNews__top">
        <div *ngIf="!this.showDescription" class="cardNews__top__badge d-flex">
            <div *ngIf="article?.category" class="badgeItem badgeItem--blue text-uppercase fw-500 me-1 px-1">
                {{this.main.handleCategoryArticle(article?.category)}}</div>
            <div *ngIf="article?.zone?.name"
                class="badgeItem badgeItem--orange text-uppercase textOneLine fw-500 ms-1 px-1">{{article?.zone?.name}}
            </div>
        </div>
        <img [class.allBorderRound]="isLateralCard" [ngSrc]="this.imageArticle()" fill alt="immagine cover card news">
        <div class="patinaNews patinaNews--card" [class.allBorderRound]="isLateralCard"></div>
    </div>
    <div [class.cardBorder]="!isLateralCard" [class.bg-blue]="bgType === 'blue'" [class.bg-orange]="bgType === 'orange'"
        class="cardNews__info">
        <h4 [class.pb-2]="!isLateralCard && this.isNewsAgentCard"
            [class.titleArticle--twoLine]="!isLateralCard && this.isNewsAgentCard" class="mb-0 titleArticle fw-600">
            {{article?.title}}</h4>
        <p *ngIf="this.showDescription" class="mb-0 pb-3 pt-2">{{this.article?.excerpt}}</p>

        <div *ngIf="this.showDescription"
            class="d-flex align-items-center justify-content-between pb-3 dateAndCategoryCont">
            <div class="d-flex dateAndCategoryCont__cat">
                <div *ngIf="article?.category" class="badgeItem badgeItem--blue text-uppercase fw-500 px-1 me-1">
                    {{this.main.handleCategoryArticle(article?.category)}}</div>
                <div *ngIf="article?.zone?.name"
                    class="badgeItem badgeItem--orange text-uppercase textOneLine ms-1 fw-500 px-1">
                    {{article?.zone?.name}}</div>
            </div>
            <p class="mb-0 date">{{article?.created_at | date:'dd/MM/yyyy'}}</p>
        </div>
        <div *ngIf="!isLateralCard" class="cardNews__info__author d-flex align-items-center pt-3">
            <div class="cardNews__info__author__img position-relative me-2">
                <img ngSrc="{{this.main.generatePictureUrl(this.article?.writtenBy?.profile_img, '80', 'agent')}}"
                    fill="center" alt="immagine autore card news">
            </div>

            <div>
                <p class="mb-0 text-uppercase">Autore</p>
                <p class="mb-0 fw-500">{{article?.writtenBy?.first_name}} {{article?.writtenBy?.last_name}}</p>
            </div>
        </div>
        <p *ngIf="isLateralCard && article?.writtenBy" class="mb-0">di {{article?.writtenBy?.first_name}}
            {{article?.writtenBy?.last_name}}</p>
    </div>
</div>